const placeholderImage = {
  url: "https://static-grandvision.imgix.net/grandvision/fallback.png",
  label: "",
  dimensions: {
    h: 0,
    w: 0
  }
};
export {
  placeholderImage
};
//# sourceMappingURL=placeholder-image.js.map
